import { render } from "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=template&id=a33a59de&scoped=true"
import script from "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=style&index=0&id=a33a59de&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a33a59de"]])

export default __exports__